import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';
import {MyLearnersGroup} from './my-learners.group';
import {MonitoringAndStatisticsGroup} from './monitoring-and-statistics.group';

export const ManageGroup = (context: NavigationContext): LinkGroup => ({
    type: 'linkGroup',
    label: 'navigation.manage',
    links: [
        MyLearnersGroup(context),
        MonitoringAndStatisticsGroup(context)
    ]
});